import { Card, CardContent } from '@sea-snag/ui';
import type { LucideIcon } from 'lucide-react';

interface StatCardProps {
  icon: LucideIcon;
  value: string | number;
  label: string;
  /** Second line, for the caveat a headline figure needs to be read correctly. */
  hint?: string;
  className?: string;
}

export function StatCard({ icon: Icon, value, label, hint, className }: StatCardProps) {
  return (
    <Card className={className}>
      <CardContent className="p-3">
        <div className="flex items-center gap-2 text-muted-foreground">
          <Icon className="size-4" />
          <span className="text-xs">{label}</span>
        </div>
        <p className="mt-1 text-lg font-semibold">{value}</p>
        {hint && <p className="text-muted-foreground mt-0.5 text-xs">{hint}</p>}
      </CardContent>
    </Card>
  );
}
